<template lang="pug">
.send-document-remind-table-component
  // テーブル
  b-table(
    :items="_value"
    :fields="fields"
    :current-page="currentPage"
    :per-page="perPage"
    :busy="isLoading"
    sticky-header
    no-border-collapse
    table-class="basic-table"
    show-empty
  )
    // ローディング
    template(#table-busy)
      .text-center.table-loading-message
        b-spinner.spinner
        span.message.align-self-center 読込み中...
    // レコード無し
    template(#empty)
      .empty-message
        span 情報がありません
    // フィルター後レコード無し
    template(#emptyfiltered)
      .empty-message
        span 情報がありません

    // セル：再送日時
    template(#cell(sendDatetime)="row")
      span {{ convertSendDatetimeLabel(row.item.sendDatetime) }}
    // セル：宛先
    template(#cell(targets)="row")
      .d-flex
        span.target-name.flex-fill.align-self-center {{ convertSendTargetLabel(row.item) }}
        button.btn.target-list-btn(@click="onShowTarget(row.item)") 宛先一覧
    // セル：タイトル
    template(#cell(title)="row")
      span {{ row.item.title }}
    // セル：本文
    template(#cell(text)="row")
      span {{ row.item.text }}
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";
import {
  GroupOtherUserGroupInfo,
  ResidentGroupInfo,
  SendDocumentFamilyReceiver,
  SendDocumentGetModel,
  SendDocumentOtherUserReceiver,
  SendMessageGroupInfo,
  Type
} from "@/commons/services/SendDocuments";

/**
 * ### 部屋テーブルコンポーネント
 */
@Component({})
export default class SendDocumentRemindTable extends Vue {
  /** 1行あたりの情報配列 */
  @Prop({ required: true })
  value!: Array<SendDocumentRemindTableItem>;
  /** 列名配列 */
  @Prop({ required: true })
  fields!: Array<SendDocumentRemindTableField>;
  /** 全体行数 */
  @Prop({ required: true })
  totalRows!: number;
  /** 現在のページ */
  @Prop({ required: true })
  currentPage!: number;
  /** 1ページあたりの表示行数 */
  @Prop({ required: true })
  perPage!: number;
  /** ローディング表示可否 */
  @Prop({ required: true })
  isLoading!: boolean;

  get _value(): Array<SendDocumentRemindTableItem> {
    return this.value;
  }

  /** ### 宛先文字列を返す */
  public convertSendTargetLabel(item: SendDocumentRemindTableItem): string {
    let sendTargets: string[] = [];
    switch (item.type) {
      case Type.ALL_FAMILY: {
        sendTargets.push("家族全員");
        break;
      }
      case Type.SELECTED_FAMILY: {
        for (const receiver of item.receivers as Array<SendDocumentFamilyReceiver>) {
          sendTargets.push(`${receiver.familyName}（${receiver.room}・${receiver.name}）`);
        }
        break;
      }
      case Type.SELECTED_OTHER_USER: {
        for (const receiver of item.receivers as Array<SendDocumentOtherUserReceiver>) {
          sendTargets.push(receiver.memberName);
        }
        break;
      }
      case Type.SEND_MESSAGE_GROUP: {
        for (const group of item.sendMessageGroupInfos as Array<SendMessageGroupInfo>) {
          sendTargets.push(group.name);
        }
        break;
      }
      case Type.RESIDENT_GROUP: {
        for (const group of item.residentGroupInfos as Array<ResidentGroupInfo>) {
          sendTargets.push(group.name);
        }
        break;
      }
      case Type.OTHER_USER_GROUP: {
        for (const group of item.otherUserGroupInfos as Array<GroupOtherUserGroupInfo>) {
          sendTargets.push(group.name);
        }
        break;
      }
    }

    return sendTargets.join("、");
  }

  public onShowTarget(item: SendDocumentRemindTableItem): void {
    this.$emit("onShowTarget", item);
    return;
  }

  public convertSendDatetimeLabel(sendDatetime: number | null): string {
    if (sendDatetime == null) {
      return "";
    }
    const datetime: string = this.$dateUtil.convertNumberToString(sendDatetime, "mm月dd日 hh:MM");

    return datetime;
  }
}

/** テーブルの列名の情報 */
export interface SendDocumentRemindTableField {
  key: string;
  label: string;
  sortable: boolean;
  sortDirection: string;
  class?: string;
}

/** テーブルの1行あたりの情報 */
export interface SendDocumentRemindTableItem extends SendDocumentGetModel {}
</script>

<style lang="scss" scoped>
@import "../../../styles/pc/_colors.scss";
@import "../../../styles/pc/_mixin.scss";

.send-document-remind-table-component {
  // テーブルがタブの横幅を超えるため、サイズ指定をする必要がある
  width: 100%;
}
</style>
